export class ArgumentNullError extends Error {
    /**
     * @param {String} argumentName
     * @param {String} caller
     */
    constructor(argumentName, caller) {
        super(`Argument ${argumentName} cannot be null (caller: ${caller})`)
    }

    /**
     * @param {any} argumentValue
     * @param {String} argumentName
     * @param {String} caller
     */
    static throw(argumentValue, argumentName, caller) {
        if (argumentValue == undefined || argumentValue == null)
            throw new ArgumentNullError(argumentName, caller)
    }
}
